import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Creator {
  id: number;
  name: string;
  category: string;
  language: string;
  followers: string;
  earnings: string;
  image: string;
  alt: string;
  verified: boolean;
  badge: string;
}

const featuredCreators: Creator[] = [
{
  id: 1,
  name: "Priya Sharma",
  category: "Romance Storyteller",
  language: "Hindi",
  followers: "2.5M",
  earnings: "₹8.5L/month",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_111e29bbe-1763294966477.png",
  alt: "Indian woman with long black hair wearing traditional red saree smiling at camera in bright studio",
  verified: true,
  badge: "Top Creator"
},
{
  id: 2,
  name: "Rajesh Kumar",
  category: "Thriller Podcaster",
  language: "Tamil",
  followers: "1.8M",
  earnings: "₹6.2L/month",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15afc7fe3-1763293198211.png",
  alt: "Indian man with short black hair wearing blue shirt and headphones in recording studio",
  verified: true,
  badge: "Rising Star"
},
{
  id: 3,
  name: "Ananya Desai",
  category: "Comedy Creator",
  language: "Gujarati",
  followers: "3.2M",
  earnings: "₹12L/month",
  image: "https://images.unsplash.com/photo-1688841659297-a8030834196e",
  alt: "Young Indian woman with curly hair wearing yellow top laughing while recording with microphone",
  verified: true,
  badge: "Top Creator"
},
{
  id: 4,
  name: "Vikram Singh",
  category: "Mythology Narrator",
  language: "Punjabi",
  followers: "1.5M",
  earnings: "₹5.8L/month",
  image: "https://images.unsplash.com/photo-1596598592755-834082d9f5d7",
  alt: "Indian man with beard wearing turban and traditional kurta speaking into microphone",
  verified: true,
  badge: "Cultural Icon"
},
{
  id: 5,
  name: "Meera Nair",
  category: "Self-Help Coach",
  language: "Malayalam",
  followers: "2.1M",
  earnings: "₹7.5L/month",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19205d2aa-1763296356182.png",
  alt: "Indian woman with shoulder-length hair wearing white shirt smiling while recording podcast",
  verified: true,
  badge: "Wellness Expert"
},
{
  id: 6,
  name: "Arjun Reddy",
  category: "Tech Reviewer",
  language: "Telugu",
  followers: "1.2M",
  earnings: "₹4.5L/month",
  image: "https://images.unsplash.com/photo-1666833110817-c180a2ba4d61",
  alt: "Young Indian man wearing glasses and black t-shirt sitting at desk with laptop and microphone",
  verified: true,
  badge: "Tech Guru"
}];


export default function FeaturedCreatorsSection() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-accent/10 rounded-full mb-4">
            <Icon name="StarIcon" size={20} className="text-accent" />
            <span className="text-sm font-semibold text-accent">Creator Spotlight</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-text-primary mb-4">
            Meet Our Top Storytellers
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Join thousands of successful creators who are earning while sharing their passion with millions of listeners
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredCreators.map((creator) =>
          <div
            key={creator.id}
            className="group bg-card rounded-xl overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1">

              <div className="relative h-64 overflow-hidden">
                <AppImage
                src={creator.image}
                alt={creator.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
                
                {creator.verified &&
              <div className="absolute top-4 right-4 w-8 h-8 bg-primary rounded-full flex items-center justify-center shadow-warm">
                    <Icon name="CheckBadgeIcon" size={20} className="text-primary-foreground" />
                  </div>
              }

                <div className="absolute top-4 left-4 px-3 py-1 bg-accent text-accent-foreground rounded-full text-xs font-bold">
                  {creator.badge}
                </div>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <h3 className="text-xl font-heading font-bold text-text-primary mb-1">
                    {creator.name}
                  </h3>
                  <p className="text-sm text-text-secondary">{creator.category}</p>
                </div>

                <div className="flex items-center space-x-2 text-sm text-text-secondary">
                  <Icon name="LanguageIcon" size={16} className="text-primary" />
                  <span>{creator.language}</span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <div>
                    <div className="text-xs text-text-secondary">Followers</div>
                    <div className="text-lg font-bold text-primary">{creator.followers}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-text-secondary">Monthly Earnings</div>
                    <div className="text-lg font-bold text-success">{creator.earnings}</div>
                  </div>
                </div>

                <button className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg font-cta font-bold transition-all duration-300 hover:bg-primary-dark">
                  <Icon name="UserPlusIcon" size={18} />
                  <span>Follow Creator</span>
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-12">
          <button className="inline-flex items-center space-x-2 px-8 py-4 bg-card text-text-primary border-2 border-primary rounded-lg font-cta font-bold transition-all duration-300 hover:bg-primary hover:text-primary-foreground">
            <span>View All Creators</span>
            <Icon name="ArrowRightIcon" size={20} />
          </button>
        </div>
      </div>
    </section>);

}